module.exports = __webpack_public_path__ + "80eecef464b4ab4cbbf9672a03966a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CloseIcon@2x.png
// module id = 53
// module chunks = 0